module.exports = __webpack_public_path__ + "media/images/icons/material/message-f2a3b970f30cce3fb53f255e3e2e32e9.svg";